import React, { memo, useMemo } from "react";
import "./BurgerMenu.scss";
import { Link } from "gatsby";
import { ReactSVG } from "react-svg";
import { headerLinks, TABLET_MIN_WIDTH } from "@constants";
import logo from "@images/impressit-logo.svg";
import burgerIcon from "@images/ic-burger.svg";
import closeIcon from "@images/ic-cancel.svg";
import doneIcon from "@images/ic-done.svg";
import classNames from "classnames";

const BurgerMenu = ({
    showLinks,
    handleClick,
    openMobileFilters,
    setOpenMobileFilters,
    headerTitle,
    width,
}) => {
    const menuIcon = useMemo(
        () => (showLinks ? closeIcon : burgerIcon),
        [showLinks, burgerIcon]
    );

    const menuIconClassName = classNames("burger-menu__icon", {
        "burger-menu__icon-close": !!showLinks,
    });

    const isTablet = useMemo(() => width > TABLET_MIN_WIDTH, [width]);

    return (
        <header className="burger-menu">
            <div className="burger-menu__container">
                <div className="header__logo-link-container">
                    <Link to="/" className="burger-menu__logo">
                        <ReactSVG
                            src={logo}
                            alt="Impressit logo"
                            className="burger-menu__home-logo-icon"
                        />
                    </Link>
                    {isTablet && (
                        <span className="header__text-container">
                            {headerTitle}
                        </span>
                    )}
                </div>
                <div className="burger-menu__icon-container">
                    {!openMobileFilters ? (
                        <ReactSVG
                            onClick={handleClick}
                            src={menuIcon}
                            alt="burger icon"
                            className={menuIconClassName}
                        />
                    ) : (
                        <ReactSVG
                            onClick={() => setOpenMobileFilters(false)}
                            src={doneIcon}
                            alt="done icon"
                            className="burger-menu__filters-done-icon"
                        />
                    )}
                </div>
            </div>

            {showLinks && (
                <div className="burger-menu__links-container">
                    {headerLinks.map((link, index) => {
                        const { linkName, path } = link;
                        return (
                            <Link
                                to={path}
                                key={index}
                                className="burger-menu__link"
                            >
                                {linkName}
                            </Link>
                        );
                    })}
                </div>
            )}
        </header>
    );
};

export default memo(BurgerMenu);
